// extracted by mini-css-extract-plugin
export default {"wrapper":"NoNotifications_wrapper__fLKM0","wrapper_icon":"NoNotifications_wrapper_icon__mtvIZ","subtitle":"NoNotifications_subtitle__YaS56"};